import { Link } from 'react-router-dom';
import { channels, byChannel } from '@/mocks/gossip';

export default function ChannelNav() {
  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
      {channels.map((c) => {
        const count = byChannel(c.key).length;
        return (
          <Link
            key={c.key}
            to={`/channel/${c.key}`}
            className="group flex flex-col items-center rounded-xl border border-background-200 bg-background-50 p-5 text-center transition-colors hover:border-primary-300 hover:bg-background-100"
          >
            <span className="grid h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-xl text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={c.icon}></i>
            </span>
            <h3 className="mt-3 font-heading text-base font-bold text-foreground-900">{c.label}</h3>
            <p className="mt-1 text-xs leading-5 text-foreground-500">{c.desc}</p>
            <span className="mt-2 text-xs font-bold text-primary-600">
              {count} 条内容
              <i className="ri-arrow-right-s-line align-middle"></i>
            </span>
          </Link>
        );
      })}
    </div>
  );
}